/* eslint-disable no-param-reassign */
const debounce = require('../helpers/debounce');
const isMobileLayout = require('../helpers/isMobileLayout');

/**
 * Sticky component.
 *
 * Usage:
 * Call Sticky.init() to initialize the Sticky functionalities
 *
 * Methods:
 *
 * init()
 */

const $root = document.body;

const initFor = function($el, supportMobile) {
	if (!supportMobile && isMobileLayout()) return;

	const setBodyclass = $el.hasAttribute('data-sticky-set-bodyclass');

	const reset = () => {
		$el.style.transform = '';
	};

	const update = () => {
		reset();

		const rectParent = $el.parentElement.getBoundingClientRect();
		// rectParent.y < 0 means the top of the parent is within the viewport
		// rectParent.y + rectParent.height > 0 means the bottom of the parent is within the viewport
		// This if statement checks if the parent is within the viewport, which is the container of the element to be 'sticky' in, 
		// and prevents unneeded scripting to be executed if this isn't true
		const scrollingInParent = rectParent.y < 0 &&  rectParent.y + rectParent.height > 0;
		$el.classList.toggle('is-inview', scrollingInParent);
		$root.classList.toggle('sticky-is-inview', setBodyclass && scrollingInParent);
		if(!scrollingInParent) return;

		const { top, bottom } = $el.getBoundingClientRect();;
		const expectedTop = parseInt(getComputedStyle($el).top.replace('px', '')); // The top decided by the style when position is sticky
		const difference = window.innerHeight - bottom; 
		// If the difference is more than 0, then it means the bottom of the element is within the viewport so adjustment through scripting isn't needed
		// If the expectedTop is the same as the top, then this means position:sticky is triggered and the element is sticky
		if (difference < 0 && top === expectedTop) {
			$el.style.transform = `translateY(${Math.floor(difference)}px)`;
		}
	};

	// Register listeners for scroll and resize
	// If switching to mobile view, remove functionality
	const registerListeners = () => {
		const onScroll = function() {
			update();
		};
		window.addEventListener('scroll', onScroll);

		const onResize = function() {
			if (isMobileLayout()) {
				reset();
				window.removeEventListener('resize', debounced);
				window.removeEventListener('scroll', onScroll);
			}
		};
		const debounced = debounce(onResize, 100);
		window.addEventListener('resize', debounced);
	};
	registerListeners();

	// Initial update
	update();
};

const init = () => {
	// Only init if position:sticky is supported
	if (!(CSS && CSS.supports && CSS.supports('position', 'sticky'))) return;

	const $stickies = document.querySelectorAll('.js-sticky');
	if ($stickies.length === 0) return;

	// Wait for all styling and images to load since they affect height and position
	window.addEventListener('load', () => {
		$stickies.forEach($el => {
			initFor($el, $el.hasAttribute('data-sticky-mobile'));
		});
	});
};

module.exports = init;
